import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IClearerListResponse } from '../../models/clearer/clearerList.model';

interface IInitialState {
  clearersList: IClearerListResponse[];
}
const initialState: IInitialState = {
  clearersList: [],
};

const clearerSlice = createSlice({
  name: 'clearer',
  initialState,
  reducers: {
    setClearer(state, action: PayloadAction<IInitialState>) {
      state.clearersList = action.payload.clearersList;
    },
  },
});

export const clearerActions = clearerSlice.actions;
export default clearerSlice.reducer;
